import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-hidden"
}
const _hoisted_3 = { class: "row w-full flex justify-between" }
const _hoisted_4 = { class: "flex flex-row-reverse gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mt-5 table-section" }
const _hoisted_8 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_9 = { class: "flex flex-col h-full" }
const _hoisted_10 = { class: "flex-1 overflow-auto" }
const _hoisted_11 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_12 = { class: "formcontainer flex flex-col" }
const _hoisted_13 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_16 = {
  key: 0,
  class: "error-text"
}
const _hoisted_17 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_18 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_19 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_20 = { class: "row flex flex-row w-full gap-3" }
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_23 = {
  key: 0,
  class: "error-text"
}
const _hoisted_24 = { class: "w-6/12" }
const _hoisted_25 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_26 = {
  key: 0,
  class: "error-text"
}
const _hoisted_27 = { class: "row flex flex-row w-full gap-3 mt-3" }
const _hoisted_28 = { class: "w-6/12" }
const _hoisted_29 = { class: "controllabel" }
const _hoisted_30 = ["placeholder", "maxlength"]
const _hoisted_31 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_32 = {
  key: 0,
  class: "error-text"
}
const _hoisted_33 = {
  key: 1,
  class: "error-text"
}
const _hoisted_34 = { class: "w-6/12" }
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = {
  key: 0,
  class: "error-text"
}
const _hoisted_37 = {
  key: 1,
  class: "error-text"
}
const _hoisted_38 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_39 = {
  key: 1,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "title" }, "KPI's", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex", !_ctx.columnObject ? 'filterButton' : 'filterButtondisabled pointer-events-none']),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.columnObject)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                _cache[18] || (_cache[18] = _createTextVNode(" Filters "))
              ], 2),
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addKPI()))
              }, "Add"),
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickToOpen()))
              }, "Import"),
              _createElementVNode("input", {
                type: "file",
                class: "hidden",
                accept: ".xls,.xlsx",
                ref: "file",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fileReader($event)))
              }, null, 544)
            ])
          ]),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-xs mt-3" }, " Data Oragnisation is the practice of categorizing and classifyinf data to make it more usable.Similar to a file folder,where we keep important documents ,you'll need to arrange your data in the most logical and orderly fashion ,so you -- and anyone else who accesses it -- can easily find what they're looking for .Data organization is the practice of categorizing and classifying data to make it more usable. Similar to a file folder, when we keep important documents,you'll need to arrange your data in the most logical and orderly fashion. ", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_tableData, {
              class: "flex-1 min-h-0",
              tableRowData: _ctx.tableRow,
              headersData: _ctx.headers,
              loadData: _ctx.dataLoading
            }, null, 8, ["tableRowData", "headersData", "loadData"])
          ]),
          (_ctx.showPopup)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 0,
                popUp: _ctx.showPopup
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[21] || (_cache[21] = _createElementVNode("h1", { class: "pl-2" }, "Manage KPI", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {
								_ctx.onCancelbtn();
								this.showPopup = false;
							})
                    }, _cache[20] || (_cache[20] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("fieldset", null, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel" }, "KPI Name", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                      type: "text",
                                      class: _normalizeClass(["inputboxstyling h-20 max-h-48 mt-2", {
													'is-invalid': _ctx.v$.allKpis.description.$error || _ctx.isDuplicateData.description
												}]),
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.allKpis.description) = $event)),
                                      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.allKpis.description.$touch())),
                                      placeholder: "KPI Name"
                                    }, null, 34), [
                                      [
                                        _vModelText,
                                        _ctx.allKpis.description,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ]),
                                    (_ctx.v$.allKpis.description.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          (_ctx.v$.allKpis.description.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Required"))
                                            : (_ctx.v$.allKpis.description.required && _ctx.v$.allKpis.description.restrictCharacters100.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Charcter Limit is exceeded"))
                                              : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.isDuplicateData.description)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[22] || (_cache[22] = [
                                          _createElementVNode("div", { class: "error-text text-xs" }, "KPI Name already exists.", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel" }, "Target Type", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.allKpis.targetType,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.allKpis.targetType) = $event)),
                                        options: _ctx.targetTypeOptions,
                                        optionLabel: "label",
                                        optionValue: "value",
                                        placeholder: "Please select the option",
                                        class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 kpi-operator-select", { 'is-invalid': _ctx.v$.allKpis.targetType.$error }]),
                                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.targetGreaterThanZero(_ctx.allKpis.target)))
                                      }, null, 8, ["modelValue", "options", "class"]),
                                      (_ctx.v$.allKpis.targetType.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            (_ctx.v$.allKpis.targetType.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "controllabel" }, "Condition", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.allKpis.kpiCondition,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.allKpis.kpiCondition) = $event)),
                                        options: _ctx.kpiConditionOptions,
                                        optionLabel: "label",
                                        optionValue: "value",
                                        placeholder: "Please select the option",
                                        class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 kpi-operator-select", { 'is-invalid': _ctx.v$.allKpis.kpiCondition.$error }])
                                      }, null, 8, ["modelValue", "options", "class"]),
                                      (_ctx.v$.allKpis.kpiCondition.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            (_ctx.v$.allKpis.kpiCondition.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.allKpis.targetType === 'number' ? 'Target' : 'Target(%)'), 1),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: _normalizeClass(["inputboxstyling mt-2", {
														'is-invalid': _ctx.v$.allKpis.target.$error || _ctx.validTargetError || _ctx.targetNumberLessThanZero
													}]),
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.allKpis.target) = $event)),
                                        placeholder: _ctx.allKpis.targetType === 'number' ? 'Target' : 'Target (%)',
                                        maxlength: _ctx.allKpis.targetType === 'number' ? 10 : 3,
                                        ref: "editTarget",
                                        onKeyup: _cache[11] || (_cache[11] = ($event: any) => {_ctx.targetLessThanZero(_ctx.allKpis.target); _ctx.targetGreaterThanZero(_ctx.allKpis.target); _ctx.handleTargetInput})
                                      }, null, 42, _hoisted_30), [
                                        [
                                          _vModelText,
                                          _ctx.allKpis.target,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (_ctx.v$.allKpis.target.$error || _ctx.validTargetError || _ctx.targetNumberLessThanZero)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            (_ctx.v$.allKpis.target.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.allKpis.targetType === 'number' ? 'Target is required' : 'Target (%) is required'), 1))
                                              : ((_ctx.validTargetError && !_ctx.v$.allKpis.target.required.$invalid) || (_ctx.targetNumberLessThanZero == true && !_ctx.v$.allKpis.target.required.$invalid))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.allKpis.targetType === 'number' ? 'Target is Invalid' : 'Target(%) is Invalid'), 1))
                                                : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "controllabel" }, "Weightage (%)", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: _normalizeClass(["inputboxstyling mt-2", {
														'is-invalid': _ctx.v$.allKpis.weightage.$error || _ctx.validtaionWeightageError || _ctx.numberLessThanZero,
													}]),
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.allKpis.weightage) = $event)),
                                        maxlength: "3",
                                        ref: "editWeight",
                                        placeholder: "Weightage (%)",
                                        onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.weightageLessThanZero(_ctx.allKpis.weightage) || _ctx.weightageGreaterThanZero(_ctx.allKpis) && _ctx.handleInput))
                                      }, null, 34), [
                                        [
                                          _vModelText,
                                          _ctx.allKpis.weightage,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (_ctx.v$.allKpis.weightage.$error || _ctx.validtaionWeightageError || _ctx.numberLessThanZero)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                            (_ctx.v$.allKpis.weightage.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Weightage (%) is required"))
                                              : ((_ctx.validtaionWeightageError && !_ctx.v$.allKpis.weightage.required.$invalid) || (_ctx.numberLessThanZero == true && !_ctx.v$.allKpis.weightage.required.$invalid))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Weightage(%) is Invalid"))
                                                : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      (_ctx.allKpis._id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancelbtn()))
                            }, "Reset", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'),
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addOrUpdate(_ctx.allKpis)))
                            }, "Save", 2)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mr-1.5", _ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary']),
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onCancelbtn()))
                            }, "Reset", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(_ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary'),
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addOrUpdate(_ctx.allKpis)))
                            }, "Save", 2)
                          ]))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}